import { Component } from "@angular/core";
import { LoginService } from "app/services/login/login.service";

export const MY_FORMATS = {
    parse: {
      dateInput: "DD-MM-YYYY"
    },
    display: {
      dateInput: "DD-MM-YYYY",
      monthYearLabel: "MMM YYYY",
      dateA11yLabel: "LL",
      monthYearA11yLabel: "MMMM YYYY"
    }
  };

  @Component({
      selector: 'app-desembolso',
      templateUrl: './desembolso.component.html',
      styleUrls: ['./desembolso.component.scss']
  })

  export class DesembolsoComponent {

    user:any;
    flag:boolean = true;
    constructor(private loginService:LoginService){
      
      this.user = JSON.parse(sessionStorage.getItem('UserActive'));
      this.flag = (this.user.id_roles == 45)? false: true;
    }

    

    clickGuard(){
      this.loginService.clickGuard = true;
   }
}